import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { pecaPageRows, pecaRowsPerPageOptions } from "../pages/common/envPECA";
import { getDataApi1, loadApi, saveApi} from "../services/appApi";
import axios from "axios";
import "../assets/css/grid_table.css";
import "../assets/css/card.css";

const FirmClients  = () => {

  let emptyRow = {
  business_category_code: "",
  business_email_address: null,
  business_industry: null,
  business_legal_type: null,
  business_phone_number: null,
  business_website: null,
  city_sales_tax_id: null,
  city_sales_tax_pi: null,
  client_dba_name: "",
  client_legal_name: "",
  contact_cell_phone: null,
  contact_email_address: null,
  contact_home_phone: null,
  contact_work_phone: null,
  contact_person_name: null,
  county_sales_tax_id: "",
  county_sales_tax_pin: "",
  created_by: null,
  created_date: "",
  federal_tax_id: "",
  firm_client_id: null,
  firm_id: null,
  last_update_date: "",
  last_updated_by: null,
  legal_address_city: null,
  legal_address_country_code: null,
  legal_address_county: null,
  legal_address_foreign_flag: null,
  legal_address_line1: null,
  legal_address_line2: null,
  legal_address_province_name: null,
  legal_address_state: null,
  legal_address_zip: null,
  mail_address_city: null,
  mail_address_country_code: null,
  mail_address_county: null,
  mail_address_foreign_flag: null,
  mail_address_line1: null,
  mail_address_line2: null,
  mail_address_province_name: null,
  mail_address_state: null,
  mail_address_zip: null,
  physical_address_city: null,
  physical_address_country_code: null,
  physical_address_county: null,
  physical_address_foreign_flag: null,
  physical_address_line1: null,
  physical_address_line2: null,
  physical_address_province_name: null,
  physical_address_state: null,
  physical_address_zip: null,
  registered_state_code: null,
  responsible_person_email: null,
  responsible_person_name: null,
  responsible_person_phone: null,
  responsible_person_ssn: null,
  responsible_person_title: null,
  state_payroll_tax_id: "",
  state_registration_date: null,
  state_registration_id: "",
  state_sales_tax_id: null,
  state_unemp_tax_id: null
  };

  const emptyDtlRow = {
    account_description: null,
    account_type_code: "",
    bank_account_id: null,
    bank_account_number: "",
    bank_name: "",
    bank_routing_number: "",
    business_category_code: "",
    business_checking_bank: null,
    business_checking_number: null,
    business_checking_routing: null,
    business_email_address: null,
    business_industry: null,
    business_legal_type: null,
    business_phone_number: null,
    business_website: null,
    cash_gl_account_id: null,
    city_sales_tax_id: null,
    city_sales_tax_pi: null,
    client_dba_name: "",
    client_legal_name: "",
    contact_cell_phone: "",
    contact_email_address: "",
    contact_home_phone: null,
    contact_work_phone: null,
    county_sales_tax_id: "",
    county_sales_tax_pin: "",
    federal_tax_id: "",
    firm_client_id: null,
    firm_id: null,
    legal_address_city: "",
    legal_address_country_code: null,
    legal_address_foreign_flag: null,
    legal_address_line1: "",
    legal_address_line2: null,
    legal_address_province_name: null,
    legal_address_state: "",
    legal_address_zip: "",
    mail_address_city: null,
    mail_address_country_code: null,
    mail_address_foreign_flag: null,
    mail_address_line1: null,
    mail_address_line2: null,
    mail_address_province_name: null,
    mail_address_state: null,
    mail_address_zip: null,
    physical_address_city: "",
    physical_address_country_code: null,
    physical_address_foreign_flag: null,
    physical_address_line1: "",
    physical_address_line2: null,
    physical_address_province_name: null,
    physical_address_state: "",
    physical_address_zip: "",
    registered_state_code: "",
    state_payroll_tax_id: "",
    state_registration_date: null,
    state_registration_id: "",
    state_sales_tax_id: null,
    state_unemp_tax_id: ""
  }

  const [rows, setRows] = useState([]);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [showProductDtlDialog, setShowProductDtlDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [globalFilter1, setGlobalFilter1] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading1, setIsLoading1] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [expandedRowId, setExpandedRowId] = useState([]);
  const [firmFCBankAccounts, setFirmFCBankAccounts] = useState({});
  const [dtlRow, setDtlRow] = useState(emptyDtlRow);
  const [loadingRowId, setLoadingId] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const dt1 = useRef(null);
  const fetchStarted = useRef(false);
  const prevExpanRef = useRef([]);

    const fetchRows = async () => {
      try {
        let offset = 0;
        let limit = 25;
        let hasMore = true;
        let allData = [];
        let status = null;
        setIsLoading(true);
        while (hasMore) {
        const response = await getDataApi1("/ords/book/firmClientsR/");
        console.log("Response:", response);
        allData = [...allData, ...response.data.items];
        console.log("allData:", allData);
        status =  response.status;
        hasMore = response.hasMore;
        offset = offset + limit;
        }
        // console.log("Response:", response);
        // console.log("response.data.items.length: ",response.data.items.length)
        // console.log("response.data.items: ",response.data.items)
        // console.log("Fetched Data:", allData);
        if (status == 200 && !hasMore) {
          if (allData.length > 0) {
             toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(allData);
            setIsLoading(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            const errorInfo = "Error";

            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching data:", error);
      }
    }
    };
  useLayoutEffect(() => {
     if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
     }
  }, []);

  const hideDialog = () => {
    setShowProductDialog(false);
    setShowProductDtlDialog(false);
    setErrorDialogVisible(false);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
}
const showDtlProduct = (dtlRow) => {
    setDtlRow({ ...dtlRow });
    setShowProductDtlDialog(true);
}

const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="flex justify-content-center align-items-center min-h-screen p-5">
        <Card className="w-full sm:w-30rem shadow-3 border-1 border-primary overflow-hidden">
            <div style={{backgroundColor: 'var(--primary-color'}} className="text-white p-3 text-center border-round-top">
                <h2 className="m-0">Firm Clients Table</h2>
            </div>
            <div className="p-4 text-center bg-white">
                <h3 className="text-900 m-0">The Page is loading...</h3>
            </div>
        </Card>
      </div>
    </React.Fragment>
  );
}
const getLoadedHeaderContents = () => {
                return (
                  <React.Fragment>
                    <div className="header-container">
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      Firm Clients
                      </h2>
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        <div className="header-container p-1">
                            <style>
                            {`
                              input::placeholder {
                                font-size: 17px; 
                              }
                            `}
                          </style>
                        <span className="p-input-icon-right w-full md:w-auto"> 
                      <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="w-full lg:w-auto text-sm p-3"
                        style={{ fontSize: '17px' }} 
                      />
                    </span>
                        </div>
                      </h2>
                    </div>
                  </React.Fragment>
                );
              }

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );


  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const dtlReadBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showDtlProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const getMaskedValue = (value) => value == null ? null:'*'.repeat(value.length);

  const fetchFirmFCBankAccounts = async (firm_client_id) => {
    setIsLoading1(true);
    setLoadingId(firm_client_id);
    console.log("Firm Client Id: ",firm_client_id);
    try {
      let offset = 0;
      let limit = 25;
      let hasMore = true;
      let allData1 = [];
      let status = null;
      while (hasMore) {
      const response = await getDataApi1(
        `/ords/book/firmFCBankAccountsR/?q={"firm_client_id":${firm_client_id}}`
      );
      console.log( `/ords/book/firmFCBankAccountsR/?q={"firm_client_id":${firm_client_id}}`)
        allData1 = [...allData1, ...response.data.items];
        status =  response.status;
        hasMore = response.hasMore;
        offset = offset + limit;
      console.log("Fetched FirmFCBankAccounts:", response.data);
    }

      if (allData1.length > 0) {
          setFirmFCBankAccounts((prevFirmFCBankAccounts) => ({
            ...prevFirmFCBankAccounts,
            [firm_client_id]: allData1,
          }));
          setIsLoading1(false);
      } else {
        setFirmFCBankAccounts((prevFirmFCBankAccounts) => ({ ...prevFirmFCBankAccounts, [firm_client_id]: [] }));
        setIsLoading1(false);
      }
    } catch (error) {
      console.error("Error fetching firmFCBankAccounts:", error);
    } finally {
      setIsLoading1(false);
      setLoadingId(null);
    }
  };

  useEffect(() => {
    const prevExpanded = prevExpanRef.current;
      const newlyExpanded = expandedRowId.filter((id) => !prevExpanded.includes(id))
      newlyExpanded.forEach((firm_client_id) => {
      if(firm_client_id) {
        fetchFirmFCBankAccounts(firm_client_id);
      }
    });
    prevExpanRef.current = expandedRowId;
  }, [expandedRowId])
 

  const drillDownTemplate = (rowData) => {
    const isExpanded = expandedRowId.includes(rowData.firm_client_id);

    return (
      <Button
        icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
        className={`p-button-rounded p-button-sm ${
          isExpanded ? "p-button-danger" : "p-button-primary"
        }`}
        onClick={() => toggleRowExpansion(rowData.firm_client_id)}
        tooltip="Detail"
        tooltipOptions={{ position: "bottom" }}
        style={{ fontSize: "1rem" }}
      />
    );
  };

  const toggleRowExpansion = (rowId) => {
    setExpandedRowId((prevExpandedRowId) =>
      prevExpandedRowId.includes(rowId)
        ? prevExpandedRowId.filter((id) => id !== rowId)
        : [...prevExpandedRowId, rowId]
    );
  };

  const rowExpansionTemplate = (data) => {
    const firmFCBankAccountsData = firmFCBankAccounts[data.firm_client_id] || [];
    const exportCSV1 = () => {
      dt1.current.exportCSV();
    };

    return (
      <div className="p-3">
        {loadingRowId == data.firm_client_id && (<h4>The data is loading...</h4>)}
        {loadingRowId != data.firm_client_id && (<>
        <div className="header-container">
          <div className="header-container p-1">
            <style>
              {`
                input::placeholder {
                  font-size: 17px;
                }
              `}
            </style>
            <span className="p-input-icon-right w-full md:w-auto">
              <InputText
                type="search"
                onInput={(e) => setGlobalFilter1(e.target.value)}
                placeholder="Search..."
                className="w-full lg:w-auto text-sm p-3"
                style={{ fontSize: "17px" }}
              />
            </span>
            <Button
              icon="pi pi-upload"
              className="p-button-primary p-button-rounded"
              onClick={exportCSV1}
              tooltip="Export"
              tooltipOptions={{ position: "bottom" }}
              style={{ marginLeft: "20px", marginBottom: "10px" }}
            />
            <span style={{marginLeft: "20px"}}>
              <b>No. of Rows :</b> {firmFCBankAccountsData.length}
            </span>
          </div>
        </div>
        <DataTable
          ref={dt1}
          value={firmFCBankAccountsData}
          dataKey={firmFCBankAccountsData.bank_account_id}
          responsiveLayout="scroll"
          globalFilter={globalFilter1}
          removableSort
        >
          <Column body={dtlReadBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column field="account_type_code" header="Account Type" sortable></Column>
          <Column field="bank_name" header="Bank Name" sortable></Column>
          <Column field="bank_routing_number" header="Routing Number" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="bank_account_number" header="Account Number" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="state_registration_id" header="State Regn Id(SOS)" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="client_legal_name" header="Legal Name" sortable></Column>
          <Column field="client_dba_name" header="DBA Name" sortable></Column>
          <Column field="federal_tax_id" header="Fed Tax Id" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="state_payroll_tax_id" header="State Tax Id" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="state_unemp_tax_id" header="State Unemp Tax Id" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="county_sales_tax_id" header="County Tax Id" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="county_sales_tax_pin" header="County PIN" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="contact_cell_phone" header="Contact Cell Phone" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="contact_email_address" header="Contact Email" sortable></Column>
          <Column field="legal_address_line1" header="Legal Address 1" sortable></Column>
          <Column field="legal_address_line2" header="Legal Address 2" sortable></Column>
          <Column field="legal_address_city" header="Legal City" sortable></Column>
          <Column field="legal_address_state" header="Legal State" sortable></Column>
          <Column field="legal_address_zip" header="Legal Zip" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="business_phone_number" header="Business Phone#" sortable></Column>
          <Column field="business_email_address" header="Business Email" sortable></Column>
          <Column field="business_website" header="Business Website" sortable></Column>
        </DataTable>
        </>
        )}
      </div>
    );
  };

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!isLoading && (
      <div className="card mb-3">
        {/* <div className="text-3xl text-800 font-bold mb-4"> Firm Clients</div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="firm_client_id"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={pecaPageRows}
          rowsPerPageOptions={pecaRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
          removableSort
          expandedRows={expandedRowId.map((firm_client_id) =>
                rows.find((rows) => rows.firm_client_id === firm_client_id)
              )}
              onRowToggle={(e) => {
                const rowId = e.data ? e.data.firm_client_id : null;
                setExpandedRowId((prev) =>
                  prev.includes(rowId)
                    ? prev.filter((firm_client_id) => firm_client_id !== rowId)
                    : [...prev, rowId]
                );
              }}
          rowExpansionTemplate={rowExpansionTemplate}
        >
         
          <Column body={readBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column body={drillDownTemplate} style={{ width: "3rem", textAlign: "center" }}/>
          <Column field="client_legal_name" header="Name" sortable></Column>
          <Column field="client_dba_name" header="DBA Name" sortable></Column>
          <Column field="federal_tax_id" header="Federal Tax ID" sortable></Column>
          <Column field="state_payroll_tax_id" header="State Payroll Tax ID" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="legal_address_county" header="Legal Address County Name" sortable></Column>
          <Column field="mail_address_county" header="Mail Address County Name" sortable></Column>
          <Column field="physical_address_county" header="Physical Address County Name" sortable></Column>
          <Column field="county_sales_tax_id" header="County Sales Tax ID" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="county_sales_tax_pin" header="County Sales Tax PIN" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="state_registration_id" header="State Regn Id[SOS]" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="contact_cell_phone" header="Contact Cell Phone" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="contact_email_address" header="Contact Email" sortable></Column>
          <Column field="legal_address_line1" header="Legal Address 1" sortable></Column>
          <Column field="legal_address_line2" header="Legal Address 2" sortable></Column>
          <Column field="legal_address_city" header="Legal City" sortable></Column>
          <Column field="legal_address_state" header="Legal state" sortable></Column>
          <Column field="legal_address_zip" header="Legal Zip" bodyStyle={{ textAlign: "right" }} sortable></Column>
          <Column field="business_phone_number" header="Business Phone#" sortable></Column>
          <Column field="business_email_address" header="Business Email" sortable></Column>
          <Column field="business_website" header="Business Website" sortable></Column>
          <Column field="contact_person_name" header="Contact Person Name" sortable></Column>
          <Column field="responsible_person_name" header="Responsible Person Name" sortable></Column>
          <Column field="responsible_person_phone" header="Responsible Person Phone" sortable></Column>
          <Column field="responsible_person_email" header="Responsible Person Email" sortable></Column>
          <Column field="responsible_person_title" header="Responsible Person Title" sortable></Column>
          <Column field="responsible_person_ssn" header="Responsible Person SSN" body={(rowData) => getMaskedValue(rowData.responsible_person_ssn)} sortable></Column>
          <Column field="mail_address_line1" header="Mail Address 1" sortable></Column>
          <Column field="mail_address_line2" header="Mail Address 2" sortable></Column>
          <Column field="mail_address_city" header="Mail City" sortable></Column>
          <Column field="mail_address_state" header="Mail state" sortable></Column>
          <Column field="mail_address_zip" header="Mail Zip" sortable></Column>
          <Column field="physical_address_line1" header="Physical Address 1" sortable></Column>
          <Column field="physical_address_line2" header="Physical Address 2" sortable></Column>
          <Column field="physical_address_city" header="Physical City" sortable></Column>
          <Column field="physical_address_state" header="Physical state" sortable></Column>
          <Column field="physical_address_zip" header="Physical Zip" bodyStyle={{ textAlign: "right" }} sortable></Column>
        </DataTable>
      </div>
      )}

      <Dialog visible={showproductDialog} style={{ width: '37.5rem' }} header="Firm Clients" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="client_legal_name">Name</label>
                    <div className="box">
                        {row.client_legal_name}
                    </div>

                <label htmlFor="federal_tax_id">Federal Tax ID</label>
                    <div className="box">
                        {row.federal_tax_id}
                    </div>

                <label htmlFor="state_payroll_tax_id">State Payroll Tax ID</label>
                    <div className="box">
                        {row.state_payroll_tax_id}
                    </div>

                <label htmlFor="legal_address_county">Legal Address County Name</label>
                    <div className="box">
                        {row.legal_address_county}
                    </div>
                <label htmlFor="mail_address_county">Mail Address County Name</label>
                    <div className="box">
                        {row.mail_address_county}
                    </div>
                <label htmlFor="physical_address_county">Physical Address County Name</label>
                    <div className="box">
                        {row.physical_address_county}
                    </div>

                <label htmlFor="county_sales_tax_id">County Sales Tax ID</label>
                    <div className="box">
                        {row.county_sales_tax_id}
                    </div>
                <label htmlFor="county_sales_tax_pin">County Sales Tax PIN</label>
                    <div className="box">
                        {row.county_sales_tax_pin}
                    </div>
                <label htmlFor="state_registration_id">State Regn Id[SOS]</label>
                    <div className="box">
                        {row.state_registration_id}
                    </div>
                <label htmlFor="contact_cell_phone">Contact Cell Phone</label>
                    <div className="box">
                        {row.contact_cell_phone}
                    </div>
                <label htmlFor="contact_email_address">Contact Email</label>
                    <div className="box">
                        {row.contact_email_address}
                    </div>
                 <label htmlFor="legal_address_line1">Legal Address 1</label>
                    <div className="box">
                        {row.legal_address_line1}
                    </div>
                   <label htmlFor="legal_address_line2">Legal Address 2</label>
                    <div className="box">
                        {row.legal_address_line2}
                    </div>
                     <label htmlFor="legal_address_city">Legal City</label>
                    <div className="box">
                        {row.legal_address_city}
                    </div>
                     <label htmlFor="legal_address_state">Legal state</label>
                    <div className="box">
                        {row.legal_address_state}
                    </div>
                     <label htmlFor="legal_address_zip">Legal Zip</label>
                    <div className="box">
                        {row.legal_address_zip}
                    </div>
                     <label htmlFor="business_phone_number">Business Phone#</label>
                    <div className="box">
                        {row.business_phone_number}
                    </div>
                     <label htmlFor="business_email_address">Business Email</label>
                    <div className="box">
                        {row.business_email_address}
                    </div>
                     <label htmlFor="business_website">Business Website</label>
                    <div className="box">
                        {row.business_website}
                    </div>
                    <label htmlFor="contact_person_name">Contact Person Name</label>
                    <div className="box">
                        {row.contact_person_name}
                    </div>
                    <label htmlFor="responsible_person_name">Responsible Person Name</label>
                    <div className="box">
                        {row.responsible_person_name}
                    </div>
                    <label htmlFor="responsible_person_phone">Responsible Person Phone</label>
                    <div className="box">
                        {row.responsible_person_phone}
                    </div>
                    <label htmlFor="responsible_person_email">Responsible Person Email</label>
                    <div className="box">
                        {row.responsible_person_email}
                    </div>
                    <label htmlFor="responsible_person_title">Responsible Person Title</label>
                    <div className="box">
                        {row.responsible_person_title}
                    </div>
                    <label htmlFor="responsible_person_ssn">Responsible Person SSN</label>
                    <div className="box">
                        {getMaskedValue(row.responsible_person_ssn)}
                    </div>
                     <label htmlFor="mail_address_line1">Mail Address 1</label>
                    <div className="box">
                        {row.mail_address_line1}
                    </div>
                     <label htmlFor="mail_address_line2">Mail Address 2</label>
                    <div className="box">
                        {row.mail_address_line2}
                    </div>
                     <label htmlFor="mail_address_city">Mail City</label>
                    <div className="box">
                        {row.mail_address_city}
                    </div>
                     <label htmlFor="mail_address_state">Mail state</label>
                    <div className="box">
                        {row.mail_address_state}
                    </div>
                     <label htmlFor="mail_address_zip">Mail Zip</label>
                    <div className="box">
                        {row.mail_address_zip}
                    </div>
                     <label htmlFor="physical_address_line1">Physical Address 1</label>
                    <div className="box">
                        {row.physical_address_line1}
                    </div>
                     <label htmlFor="physical_address_line2">Physical Address 2</label>
                    <div className="box">
                        {row.physical_address_line2}
                    </div>
                     <label htmlFor="physical_address_city">Physical City</label>
                    <div className="box">
                        {row.physical_address_city}
                    </div>
                     <label htmlFor="physical_address_state">Physical state</label>
                    <div className="box">
                        {row.physical_address_state}
                    </div>
                     <label htmlFor="physical_address_zip">Physical Zip</label>
                    <div className="box">
                        {row.physical_address_zip}
                    </div>

            </Dialog>
            <Dialog visible={showProductDtlDialog} style={{ width: '37.5rem' }} header="Firm Clients" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="account_type_code">Account Type</label>
                    <div className="box">
                        {dtlRow.account_type_code}
                    </div>
                 <label htmlFor="bank_name">Bank Name</label>
                    <div className="box">
                        {dtlRow.bank_name}
                    </div>
                   <label htmlFor="bank_routing_number">Routing Number</label>
                    <div className="box">
                        {dtlRow.bank_routing_number}
                    </div>
                     <label htmlFor="bank_account_number">Account Number</label>
                    <div className="box">
                        {dtlRow.bank_account_number}
                    </div>
                     <label htmlFor="state_registration_id">State Regn Id(SOS)</label>
                    <div className="box">
                        {dtlRow.state_registration_id}
                    </div>
                    <label htmlFor="client_legal_name">Legal Name</label>
                    <div className="box">
                        {dtlRow.client_legal_name}
                    </div>

                <label htmlFor="client_dba_name">DBA Name</label>
                    <div className="box">
                        {dtlRow.client_dba_name}
                    </div>

                <label htmlFor="federal_tax_id">Fed Tax Id</label>
                    <div className="box">
                        {dtlRow.federal_tax_id}
                    </div>

                <label htmlFor="state_payroll_tax_id">State Tax Id</label>
                    <div className="box">
                        {dtlRow.state_payroll_tax_id}
                    </div>
                <label htmlFor="state_unemp_tax_id">State Unemp Tax Id</label>
                    <div className="box">
                        {dtlRow.state_unemp_tax_id}
                    </div>
                <label htmlFor="county_sales_tax_id">County Tax Id</label>
                    <div className="box">
                        {dtlRow.county_sales_tax_id}
                    </div>
                <label htmlFor="county_sales_tax_pin">County PIN</label>
                    <div className="box">
                        {dtlRow.county_sales_tax_pin}
                    </div>
                     <label htmlFor="contact_cell_phone">Contact Cell Phone</label>
                    <div className="box">
                        {dtlRow.contact_cell_phone}
                    </div>
                     <label htmlFor="legal_address_line1">Legal Address 1</label>
                    <div className="box">
                        {dtlRow.legal_address_line1}
                    </div>
                     <label htmlFor="legal_address_line2">Legal Address 2</label>
                    <div className="box">
                        {dtlRow.legal_address_line2}
                    </div>
                     <label htmlFor="legal_address_city">Legal City</label>
                    <div className="box">
                        {dtlRow.legal_address_city}
                    </div>
                     <label htmlFor="legal_address_state">Legal State</label>
                    <div className="box">
                        {dtlRow.legal_address_state}
                    </div>
                     <label htmlFor="legal_address_zip">Legal Zip</label>
                    <div className="box">
                        {dtlRow.legal_address_zip}
                    </div>
                     <label htmlFor="business_phone_number">Business Phone#</label>
                    <div className="box">
                        {dtlRow.business_phone_number}
                    </div>
                     <label htmlFor="business_email_address">Business Email</label>
                    <div className="box">
                        {dtlRow.business_email_address}
                    </div>
                     <label htmlFor="business_website">Business Website</label>
                    <div className="box">
                        {dtlRow.business_website}
                    </div>
            </Dialog>
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{ width: '400px' }} 
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            </div>
    </div>
  );
};

export default FirmClients;

